import { Component, OnInit } from '@angular/core';
import { RolesService } from './roles.service';
import {permissions} from '../../../permissions';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
  providers: [
    RolesService
  ],
})
export class RolesComponent implements OnInit {

    public  permissions = permissions;

    constructor(
        private router: Router,
        private title: Title
    ) {
        this.title.setTitle('Admin - Roles');
    }

    ngOnInit() {}

    addRole() {
        this.router.navigate(['rights/roles/add']);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/rights/roles/roles.component.ts